import { onReady } from '../base/init.js';
import { loadGLightbox } from '../components/glightbox-lazy.js';
import { loadSwiper } from '../base/swiper-lazy.js';

// Секция range: фильтр моделей по вкладкам (показ/скрытие card-model).
// 360-вращалка вынесена в компонент deg360 (components/deg360.js).
onReady(() => {
  const section = document.querySelector('.range');
  if (!section) return;

  const buttons = section.querySelectorAll('.js-range-filter');
  const cards = section.querySelectorAll('.card-model');
  if (!buttons.length || !cards.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const filter = btn.getAttribute('data-filter');
      buttons.forEach((b) => b.classList.toggle('active', b === btn));
      cards.forEach((card) => {
        const show = filter === 'all' || card.getAttribute('data-model') === filter;
        // скрываем flex-обёртку, а не саму карточку — иначе остаётся gap
        const wrap = card.closest('.card-model-wrap') || card;
        wrap.classList.toggle('hidden', !show);
      });
    });
  });
});

// Галереи карточек — лениво, по приближению к вьюпорту: инициализация Swiper
// читает геометрию (forced reflow ~400мс на все галереи) и не нужна в критическом
// окне LCP. До инициализации первый кадр виден CSS-раскладкой трека.
onReady(() => {
  const galleries = document.querySelectorAll('.js-card-gallery');
  if (!galleries.length) return;

  const initGallery = (el) => {
    if (el.swiperInstance) return;
    loadSwiper().then((Swiper) => {
      if (!Swiper || el.swiperInstance) return;
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 1.5,
        spaceBetween: 12,
        breakpoints: {
          768: { slidesPerView: 4 },
        },
        navigation: {
          nextEl: el.querySelector('.card-model__gallery-next'),
          prevEl: el.querySelector('.card-model__gallery-prev'),
        },
      });
    });
  };

  let lightboxInited = false;
  const initLightbox = () => {
    if (lightboxInited || !document.querySelector('.js-card-gallery-item')) return;
    lightboxInited = true;
    loadGLightbox().then((GLightbox) => {
      if (!GLightbox) return;
      GLightbox({
        selector: '.js-card-gallery-item',
        loop: true,
        touchNavigation: true,
        openEffect: 'fade',
        closeEffect: 'fade',
        cssEfects: { fade: { in: 'fadeIn', out: 'fadeOut' } },
      });
    });
  };

  if (typeof IntersectionObserver === 'undefined') {
    galleries.forEach(initGallery);
    initLightbox();
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        initGallery(entry.target);
        initLightbox();
      });
    },
    { rootMargin: '200px 0px' }
  );
  galleries.forEach((g) => io.observe(g));
});
